import { has, isPlainObject } from "lodash/fp";
const hasCurrentProperty = has("current");
function isValidRef(ref) {
  return isPlainObject(ref) && hasCurrentProperty(ref);
}
export {
  isValidRef
};
